var _circle, _path, _path2, _path3, _path4, _path5, _path6, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162,
    height: 143,
    viewBox: "0 0 162 143",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84.5586,
    cy: 71.5,
    r: 71.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.057 49.1758C136.558 49.1758 138.586 51.2037 138.586 53.7052C138.586 56.2067 136.558 58.2346 134.057 58.2346H108.174C110.676 58.2346 112.704 60.2625 112.704 62.764C112.704 65.2655 110.676 67.2934 108.174 67.2934H122.41C124.911 67.2934 126.939 69.3213 126.939 71.8228C126.939 74.3244 124.911 76.3523 122.41 76.3523H115.827C112.672 76.3523 110.116 78.3801 110.116 80.8817C110.116 82.5493 111.41 84.0591 113.998 85.4111C116.499 85.4111 118.527 87.439 118.527 89.9405C118.527 92.442 116.499 94.4699 113.998 94.4699H60.2921C57.7905 94.4699 55.7626 92.442 55.7626 89.9405C55.7626 87.439 57.7905 85.4111 60.2921 85.4111H35.0568C32.5552 85.4111 30.5273 83.3832 30.5273 80.8817C30.5273 78.3801 32.5552 76.3523 35.0568 76.3523H60.9391C63.4406 76.3523 65.4685 74.3244 65.4685 71.8228C65.4685 69.3213 63.4406 67.2934 60.9391 67.2934H44.7626C42.2611 67.2934 40.2332 65.2655 40.2332 62.764C40.2332 60.2625 42.2611 58.2346 44.7626 58.2346H70.645C68.1435 58.2346 66.1156 56.2067 66.1156 53.7052C66.1156 51.2037 68.1435 49.1758 70.645 49.1758H134.057ZM134.057 67.2934C136.558 67.2934 138.586 69.3213 138.586 71.8228C138.586 74.3244 136.558 76.3523 134.057 76.3523C131.555 76.3523 129.527 74.3244 129.527 71.8228C129.527 69.3213 131.555 67.2934 134.057 67.2934Z",
    fill: "#38879F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2344 102.88V62.6445C51.2344 58.7785 54.3684 55.6445 58.2344 55.6445H70.1608C71.6796 55.6445 72.9108 56.8757 72.9108 58.3945C72.9108 59.9133 74.1421 61.1445 75.6608 61.1445H95.6756C99.5415 61.1445 102.676 64.2785 102.676 68.1445V68.2622H103.961C108.547 68.2622 111.894 72.5979 110.733 77.0343L105.338 97.6519C104.532 100.732 101.749 102.88 98.5657 102.88H51.2344Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2344 102.88V62.6445C51.2344 58.7785 54.3684 55.6445 58.2344 55.6445H70.1608C71.6796 55.6445 72.9108 56.8757 72.9108 58.3945V58.3945C72.9108 59.9133 74.1421 61.1445 75.6608 61.1445H95.6756C99.5415 61.1445 102.676 64.2785 102.676 68.1445V68.2622M51.2344 102.88H98.5657C101.749 102.88 104.532 100.732 105.338 97.6519L110.733 77.0343C111.894 72.5979 108.547 68.2622 103.961 68.2622H102.676M51.2344 102.88L59.2158 73.431C60.0426 70.3803 62.8113 68.2622 65.9721 68.2622H102.676",
    stroke: "#38879F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54.1445 63.5547V88.9665L58.1693 73.9852C59.2295 70.0392 62.8147 67.3025 66.9006 67.3204L99.7622 67.4646C99.7622 65.224 97.9458 63.4076 95.7052 63.4076H73.8029C72.322 63.4076 71.0261 62.412 70.6445 60.9812C70.263 59.5503 68.9671 58.5547 67.4862 58.5547H59.1445C56.3831 58.5547 54.1445 60.7933 54.1445 63.5547Z",
    fill: "#38879F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M66.7547 71.1758H75.1767C77.7649 90.5875 93.9414 96.5189 101.706 97.0581L101.419 97.9186C101.011 99.1436 99.8645 99.9699 98.5732 99.9699H59.3152C57.3537 99.9699 55.9199 98.1184 56.4107 96.2193L61.9137 74.9247C62.4841 72.7177 64.4751 71.1758 66.7547 71.1758Z",
    fill: "#38879F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M81.6484 49.5L87.7955 55.9706M87.7955 49.5L81.6484 55.9706",
    stroke: "#38879F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 97.1756,
    cy: 53.0584,
    r: 1.94118,
    fill: "#38879F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 77.117,
    cy: 42.7068,
    r: 1.94118,
    stroke: "#38879F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBoard);
export default __webpack_public_path__ + "static/media/empty-board.2dbd531a55ee8e55df228a6a0022b92b.svg";
export { ForwardRef as ReactComponent };